// src/api.ts
function buildPaginationQuery(params) {
  const searchParams = new URLSearchParams();
  if (params.page) {
    searchParams.append("page", params.page.toString());
  }
  if (params.limit) {
    searchParams.append("limit", params.limit.toString());
  }
  return searchParams.toString();
}
function getPaginationInfo(response) {
  const { page, limit, total, totalPages } = response;
  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);
  return {
    start,
    end,
    total,
    totalPages,
    hasNext: page < totalPages,
    hasPrev: page > 1
  };
}

// src/auth.ts
var ROLES = ["ADMIN", "VIEWER", "TIME_TRACKER"];
function hasPermission(userRole, allowedRoles) {
  if (userRole === "ADMIN") {
    return true;
  }
  return allowedRoles.includes(userRole);
}
function getRoleLabel(role) {
  const labels = {
    ADMIN: "Administrador",
    VIEWER: "Visualizador",
    TIME_TRACKER: "Controle de Tempo"
  };
  return labels[role];
}
function getRoleBadgeColor(role) {
  const colors = {
    ADMIN: "bg-red-100 text-red-800",
    TIME_TRACKER: "bg-blue-100 text-blue-800",
    VIEWER: "bg-gray-100 text-gray-800"
  };
  return colors[role];
}
function canAccessRoute(userRole, allowedRoles) {
  if (!allowedRoles || allowedRoles.length === 0) {
    return userRole === "ADMIN";
  }
  return hasPermission(userRole, allowedRoles);
}

// src/validation.ts
function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
function isStrongPassword(password) {
  const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$!%*?&]{8,}$/;
  return strongPasswordRegex.test(password);
}
function sanitizeInput(input) {
  return input.trim().replace(/[<>]/g, "");
}

// src/constants.ts
var APP_CONFIG = {
  DEFAULT_PAGE_SIZE: 10,
  MAX_PAGE_SIZE: 100,
  PASSWORD_MIN_LENGTH: 6,
  SESSION_TIMEOUT: 15 * 60 * 1e3
  // 15 minutes in ms
};
var ROUTES = {
  LOGIN: "/login",
  DASHBOARD: "/",
  SETTINGS: "/settings",
  USERS: "/users"
};
var API_ENDPOINTS = {
  AUTH: {
    LOGIN: "/auth/login",
    REGISTER: "/auth/register",
    REFRESH: "/auth/refresh",
    LOGOUT: "/auth/logout",
    PROFILE: "/auth/profile"
  },
  USERS: {
    LIST: "/users",
    CREATE: "/users",
    UPDATE: (id) => `/users/${id}`,
    DELETE: (id) => `/users/${id}`,
    GET: (id) => `/users/${id}`
  },
  COMPANIES: {
    LIST: "/companies",
    CREATE: "/companies",
    UPDATE: (id) => `/companies/${id}`,
    DELETE: (id) => `/companies/${id}`,
    GET: (id) => `/companies/${id}`,
    SEARCH: (name) => `/companies/search?name=${name}`
  },
  CONTRACTS: {
    LIST: "/contracts",
    CREATE: "/contracts",
    UPDATE: (id) => `/contracts/${id}`,
    DELETE: (id) => `/contracts/${id}`,
    GET: (id) => `/contracts/${id}`,
    BY_COMPANY: (companyId) => `/contracts/company/${companyId}`
  },
  HEALTH: "/health"
};
export {
  API_ENDPOINTS,
  APP_CONFIG,
  ROLES,
  ROUTES,
  buildPaginationQuery,
  canAccessRoute,
  getPaginationInfo,
  getRoleBadgeColor,
  getRoleLabel,
  hasPermission,
  isStrongPassword,
  isValidEmail,
  sanitizeInput
};
